// extracted by mini-css-extract-plugin
module.exports = {"root":"bm_bj"};